export const SET_USER_EVENT_TYPE_MOUSE = 'SET_USER_EVENT_TYPE_MOUSE';
export const SET_USER_EVENT_TYPE_TOUCH = 'SET_USER_EVENT_TYPE_TOUCH';

export function setUserEventTypeMouse() {
  return {
    type: SET_USER_EVENT_TYPE_MOUSE,
  };
}

export function setUserEventTypeTouch() {
  return {
    type: SET_USER_EVENT_TYPE_TOUCH,
  };
}
